import { gql } from "@apollo/client";

export const SystemCustomerInfo = gql`
    query SystemCustomerInfo($id: ID!) {
        system(id: $id) {
            id
            client {
                id
                name
                address {
                    id
                    title
                    postalCode
                    city
                    country {
                        name
                        countryCode
                    }
                }
            }
        }
    }
`;
